

















































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import YcHeader from "@/components/common/yc-header.vue";
import YcAside from "@/components/common/yc-aside.vue";
import YcColorPicker from "@/components/color-picker/index.js";
import question from '../../../components/question.vue'
import phoneCode from '@/assets/js/phone_code.js';
import Tanchuan from '@/assets/img/common/tanchuan.svg';
import { isEnableBannerEnglishPunctuationSpacing } from '@/utils/experiment';
enum permissionType {EDIT = 'edit', CHECK = 'check'}

@Component({
  components: {
    "yc-aside": YcAside,
    "yc-header": YcHeader,
    "yc-color-picker": YcColorPicker,
    'component-question':question
  },
})
export default class fortuneStyle extends Vue {

  @Prop(String)
  activePageSetting!:string;

  // 大转盘数据
  @Prop(Object)
  formData!:object;

  @Prop(Array)
  countryList!:any


  public img = {
      Tanchuan
  }


  public color =  '#000';
  public imgNameArr = [
    { imgName: 'left_top_', top: '20px', left: '20px' },
    { imgName: 'right_top_', top: '20px', right: '20px' },
    { imgName: 'left_center_', top: '47%', left: '20px' },
    { imgName: 'right_center_', top: '47%', right: '20px' },
    { imgName: 'left_bottom_', bottom: '20px', left: '20px' },
    { imgName: 'right_bottom_', bottom: '20px', right: '20px' }
  ]
  imgNameObj ={
      "LeftTop":{ top: '20px', left: '20px'},
      "RightTop":{ top: '20px', right: '20px'},
      "LeftMiddle":{top: '47%', left: '20px'},
      "RightMiddle":{top: '47%', right: '20px'},
      "LeftBottom":{bottom: '20px', left: '20px'},
      "RightBottom":{bottom: '20px', right: '20px'},
  }
  public selectImgVis = 1

  startOrEnd = this.formData.settings.start || []

  Email=''

  iconDynamicSizing = false;
  
  selectedCountry = {
      countryAbbreviation: "US",
      phoneCode:"+1",
  }
  value1 = ''
  checkList = []
  
  iconUrl = require('@/assets/img/common/tanchuan.svg')

  created() {
      if (this.formData?.settings.position.iconUrl) {
          this.calculateSize(this.formData?.settings.position.iconUrl);
      }
  }

  // formDataStart: any = this.formData
  bannerStyle(banner){
      let style = {
      'background': `${banner.backgroundColor}`,
      'color': `${banner.textColor}`,
      'font-size': `${banner.fontSize}`,
      'font-family': `${banner.font}`
      }
      style[banner.position] = 0
      // console.log(style);
      return style
  }

  changeCountryCode(v) {
      this.selectedCountry.phoneCode = v.phoneCode;
      this.selectedCountry.countryAbbreviation = v.countryAbbreviation;
  }

  get enableBannerEnglishPunctuationSpacing() {
      return isEnableBannerEnglishPunctuationSpacing();
  }

  get bannerDisplayText() {
      const separator = this.enableBannerEnglishPunctuationSpacing ? ', ' : ',';
      const colon = this.enableBannerEnglishPunctuationSpacing ? ': ' : ':';
      return `${this.formData.settings.banner.bannerName || ''}${separator}CODE${colon}CODE`;
  }

  getFlagLocal(code:string) {
      if (typeof code == 'string') {
          const flag = phoneCode.find((item: any) => {
          return `+${item.CODE}` == code;
          });
          if (flag) {
          return `${flag.LOCAL}`.trim().toLocaleLowerCase();;
          }
          return '';
      } else {
          return (code?.countryAbbreviation ?? '').trim().toLocaleLowerCase();
      }
  }

  get iconStyles() {
      const {iconDynamicSizing} = this;

      // console.log('iconStyles before', JSON.stringify({
      //     iconWidth: this.formData?.settings.position?.iconWidth || '',
      //     iconDynamicSizing
      // }));

      if (!iconDynamicSizing) {
          // console.log('iconStyles', this.formData.settings.position?.position, JSON.stringify(this.imgNameObj[this.formData.settings.position?.position]));
          return this.imgNameObj;
      }

      // 大转盘没有移动预览
      let leftOrRight = '20px';
      // 动态尺寸icon固定100px 对齐C端
      let topOrBottom = '100px';

      // console.log('iconStyles', JSON.stringify({iconDynamicSizing, topOrBottom, leftOrRight}));
      return {
          "LeftTop":{top: topOrBottom, left: leftOrRight},
          "RightTop":{top: topOrBottom, right: leftOrRight},
          "LeftMiddle":{top: '47%', left: leftOrRight},
          "RightMiddle":{top: '47%', right: leftOrRight},
          "LeftBottom":{bottom: topOrBottom, left: leftOrRight},
          "RightBottom":{bottom: topOrBottom, right: leftOrRight},
      };
  }

  get iconSize() {
      const { iconDynamicSizing } = this;
      let width = this?.formData?.settings.position?.iconWidth || '';
      let height = this?.formData?.settings.position?.iconHeight || '';

      // console.log('iconSize before', JSON.stringify({
      //     iconDynamicSizing,
      //     iconSizeType: this.formData.settings.position?.iconSizeType,
      //     width,
      //     height
      // }));

      if (this.formData?.settings.position?.iconSizeType) {
          switch (this.formData?.settings.position?.iconSizeType) {
              case 'Small':
                  width = 30;
                  break;
              case 'Medium':
                  width = 50;
                  break;
              case 'Big':
                  width = 80;
                  break;
              default:
                  width = 50;
                  break;
          }
      }

      // 大转盘没有移动端适配
      if (iconDynamicSizing) {
          switch (this.formData.settings.position?.iconSizeType) {
              case 'Small':
                  width = 40;
                  break;
              case 'Medium':
                  width = 50;
                  break;
              case 'Big':
                  width = 65;
                  break;
              default:
                  width = 50;
                  break;
          }
      }

      // console.log('iconSize', JSON.stringify({
      //     iconDynamicSizing,
      //     iconSizeType: this.formData.settings.position?.iconSizeType,
      //     width,
      //     height
      // }));

      return {
          width,
          height
      }
  }

  @Watch("formData.settings.position.iconUrl")
  calculateSize(newval: string) {
      // console.log('formData.settings.position.iconUrl', newval);
      if (newval) {
          const img = new Image();
          img.src = newval;
          img.onload = () => {
              const width = img.width;
              const height = img.height;
              // console.log('calculateSize aspect ratio:', width, height, width / height);
              const ratio = width / height;
              if (ratio < 0.7) {
                  this.iconDynamicSizing = true;
                  // console.log(`calculateSize iconDynamicSizing=${this.iconDynamicSizing}`);
              } else {
                  this.iconDynamicSizing = false;
                  // console.log(`calculateSize iconDynamicSizing=${this.iconDynamicSizing}`);
              }
          };
      } else {
          this.iconDynamicSizing = false;
          // console.log(`calculateSize iconDynamicSizing=${this.iconDynamicSizing}`);
      }
  }

  handleCloseClick() {
      console.log('handleCloseClick');
  }


  @Watch("formData.settings.start",{immediate: true, deep:true})
  startChange(newval:number){
      if(this.activePageSetting ==='start'){
          this.startOrEnd = newval
          if(this.startOrEnd){
              this.startOrEnd.forEach(element => {
                  if(element.type == 'Mobile Number'){
                      if(element.phoneCountryAbbreviation){
                          this.selectedCountry.countryAbbreviation = element.phoneCountryAbbreviation;
                      }
                      if(element.phoneCode){
                          this.selectedCountry.phoneCode = element.phoneCode;
                      }
                  }
              })
          }
      }
  }
  @Watch("formData.settings.position.iconUrl",{immediate: true} )
  iconUrlChange(newval:string){
      if(newval){
          this.iconUrl = newval
      }else{
          // this.iconUrl = require('@/assets/img/common/tanchuan.svg')
          this.iconUrl = 'https://dvamghaolyr74.cloudfront.net/Public/cartsee/formImage/2e642a01175554bfaf5ab0b4f1c9cc03.gif';
      }
  }


  getTimeNumberString(num:any) {
      if (Number(num) < 10) {
          return `0${num}`;
      } else {
          return `${num}`
      }
  }

}
